import { COOKIE_EXPIRY_SECONDS } from '@lib/constants/cookies';

export const RECENTLY_VIEWED_COOKIE_NAME = 'as-recently-viewed';
// Max number of items to be viewed in the re-engagement block
export const RECENTLY_VIEWED_MAX_ITEMS = 8;
export const RECENTLY_VIEWED_ITEMS_PER_ROW = 4;
export const RECENTLY_VIEWED_COOKIE_MAX_AGE = COOKIE_EXPIRY_SECONDS;
